"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerAppSaveActionRequestToJSON = exports.SignerAppSaveActionRequestFromJSONTyped = exports.SignerAppSaveActionRequestFromJSON = exports.instanceOfSignerAppSaveActionRequest = exports.attributeTypeMapSignerAppSaveActionRequest = void 0;
var runtime_1 = require("../runtime");
var FieldSaveJoined_1 = require("./FieldSaveJoined");
exports.attributeTypeMapSignerAppSaveActionRequest = [
    {
        name: "signatureRequestId",
        type: "string",
    },
    {
        name: "savedData",
        type: "{ [key: string]: FieldSaveJoined; }",
    },
];
/**
 * Check if a given object implements the SignerAppSaveActionRequest interface.
 */
function instanceOfSignerAppSaveActionRequest(value) {
    if (!("signatureRequestId" in value) ||
        value["signatureRequestId"] === undefined)
        return false;
    if (!("savedData" in value) || value["savedData"] === undefined)
        return false;
    return true;
}
exports.instanceOfSignerAppSaveActionRequest = instanceOfSignerAppSaveActionRequest;
function SignerAppSaveActionRequestFromJSON(json) {
    return SignerAppSaveActionRequestFromJSONTyped(json, false);
}
exports.SignerAppSaveActionRequestFromJSON = SignerAppSaveActionRequestFromJSON;
function SignerAppSaveActionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        signatureRequestId: json["signature_request_id"],
        savedData: (0, runtime_1.mapValues)(json["saved_data"], FieldSaveJoined_1.FieldSaveJoinedFromJSON),
    };
}
exports.SignerAppSaveActionRequestFromJSONTyped = SignerAppSaveActionRequestFromJSONTyped;
function SignerAppSaveActionRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        signature_request_id: value["signatureRequestId"],
        saved_data: (0, runtime_1.mapValues)(value["savedData"], FieldSaveJoined_1.FieldSaveJoinedToJSON),
    };
}
exports.SignerAppSaveActionRequestToJSON = SignerAppSaveActionRequestToJSON;
